import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    __gmapsCallback?: () => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapLoaderService {
  private loadPromise: Promise<void> | null = null;

  load() {
    if (this.loadPromise) {
      return this.loadPromise
    }

    this.loadPromise = new Promise((resolve, reject) => {
      if ((window).google?.maps?.importLibrary) {
        resolve()
        return;
      }

      const script = document.createElement('script');
      const params = new URLSearchParams({
        key: environment.googleMapsApiKey,
        v: 'weekly',
        libraries: 'places',
        loading: 'async',
        callback: '__gmapsCallback'
      });

      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;

      window.__gmapsCallback = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Google Maps API'));

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}